"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var ResultHeader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ResultHeader, _React$Component);

  function ResultHeader() {
    (0, _classCallCheck2.default)(this, ResultHeader);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ResultHeader).apply(this, arguments));
  }

  (0, _createClass2.default)(ResultHeader, [{
    key: "render",
    value: function render() {
      var localizedTextKey = this.props.localizedTextKey;
      return _react.default.createElement("div", {
        className: "result-header"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: localizedTextKey + ".header"
      }));
    }
  }]);
  return ResultHeader;
}(_react.default.Component);

exports.default = ResultHeader;
ResultHeader.propTypes = {
  localizedTextKey: _propTypes.default.string
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/ResultHeader.js
// module id = 68
// module chunks = 0